import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest, getUserDetails } from "../../services/apiRequest";
import { requestType } from "../../services/requests";
import CatedralImg from "../../assets/images/catedral.png";
import RamblaImg from "../../assets/images/img_2.jpg";
import SeeImg from "../../assets/images/img_3.png";
import DottedLine1 from "../../assets/images/Path_39.png";
import DottedLine2 from "../../assets/images/Path_41.png";
import DottedLine3 from "../../assets/images/Path_42.png";

const shipDaysData = [
    {
        day: 1,
        isSeaDay: false,
        destination: "BARCELONA, SPAIN",
        arrive: "12:23",
        distance: "12KM",
        subHeaderTitle:
            "It’s easy to see why Barcelona is the most-visited city in Spain. Bit of fun intro text here.",
        subHeaderText:
            "As the capital of the country’s Catalonia region, this cityscape’s cultural mosaic pieces together a 2,000-year-old hodge-podge of sun-drenched beaches, cutting edge architecture and a world-renowned dining and drinking scene. <br /> <br /> Catalan architect Antoni Gaudí left his modernist handprint all over the city, while medieval treasures linger in historic Gothic Quarter squares. Get lost in the whimsical gardens of Park Güell or savour a chef-led Catalan cooking class. Browse art collections dedicated to Picasso and Miro – or ride a cable car to the top of Montjuïc Hill, relishing citywide views along the way.",
        insiderTipText:
            "One of the best ways to get round the city is by bike. There are many bire hire companies off La Rambla and guided tours.",
        thingsToDoArray: [
            {
                title: "SKY HIGH DELIGHTS",
                boxText:
                    "Get an up-close glimpse of La Sagrada Família, a cathedral masterwork designed by celebrated Catalan architect Antoni Gaudí. Marvel at its sky-piercing spires and then step inside to admire intricate mosaics, Montjuïc stone pillars and the Nativity façade. You can even climb to the tippy-top of the spires for panoramic city views.",
                imgSrc: CatedralImg,
                mainDivTop: "6.25rem",
                tagTitleLeft: "11.25rem",
                textImageDivRight: "13.25rem",
                imageTop: "5.3rem",
                imageLeft: "auto",
                textBoxTop: "22%",
                // textBoxLeft: textBoxResponsive ? "14%" : "24%",
                textBoxLeft: "24%",
                hasDepart: false,
                svgSrc: DottedLine1,
                svgTop: "-99%",
                svgRight: "12%",
            },
            {
                title: "LA RAMBLA’S DRINKS",
                boxText:
                    "Take a stroll along La Rambla’s pedestrian boulevard to experience the city’s pure essence. Souvenir shops, street artists, flower stalls, pavement cafes and Catalan folk sardana dancers set a lively scene. Its marvellous centrepiece, La Catedral, dates from the 1200s – and its tower delivers sweeping views of medieval Barcelona.",
                imgSrc: SeeImg,
                mainDivTop: "10.6rem",
                tagTitleLeft: "11.25rem",
                textImageDivRight: "13.25rem",
                imageTop: "2rem",
                imageLeft: "0",
                textBoxTop: "44%",
                textBoxLeft: "42%",
                hasDepart: false,
                svgSrc: DottedLine2,
                svgTop: "-21%",
                svgRight: "42%",
            },
            {
                title: "LOCAL CUISINE",
                boxText:
                    "Take a stroll along La Rambla’s pedestrian boulevard to experience the city’s pure essence. Souvenir shops, street artists, flower stalls, pavement cafes and Catalan folk sardana dancers set a lively scene. Its marvellous centrepiece, La Catedral, dates from the 1200s – and its tower delivers sweeping views of medieval Barcelona.",
                imgSrc: RamblaImg,
                mainDivTop: "10.6rem",
                tagTitleLeft: "18.75rem",
                textImageDivRight: "18.75rem",
                imageTop: "2rem",
                imageLeft: "18.75rem",
                textBoxTop: "71%",
                textBoxLeft: "5%",
                hasDepart: true,
                svgSrc: DottedLine3,
                svgTop: "-23%",
                svgRight: "38%",
            },
        ],
    },
    {
        day: 2,
        isSeaDay: true,
        destination: "PROVENCE (MARSEILLE), FRANCE",
        subHeaderLeftBoxTitle: "MINI GOLF",
        subHeaderLeftBoxText:
            "Up the ramp, around the curve and into the hole. Play on the green as you enjoy wide, blue ocean views. Mini golf is included in your fare, so play as much as you like. No reservation necessary.",
        subHeaderRightMainTitle: "BIGGER, BOLDER FAMILY MEMORIES.",
        subHeaderRightBoxTitle: "ESCAPE THE RUBICON",
        subHeaderRightBoxText:
            "There are some puzzles you solve and there are some puzzles you ESCAPE! In the new and exclusive Escape The Rubicon, you will be transported to another world and another time. Collaborate with friends, old and new, as you attempt to find the hidden clues needed to solve a collection of puzzles that will eventually unravel the mystery of the Rubicon!",
        secondSubHeaderLeftBoxTitle: "FLOWRIDER®",
        secondSubHeaderLeftBoxText:
            "The surf’s always up on the 40-foot-long FlowRider® surf simulator. Grab your board and get ready, 30,000 gallons of rushing awesome are headed your way.",
        secondSubHeaderInsiderTippText:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",
        thirdSectionTitle: "RAISE THE BAR",
        thirdSectionCompimentaryNr: "6",
        thirdSectionCompimentaryText: "COMPLIMENTARY <br /> RESTAURANTS",
        thirdSectionRightBoxTitle: "RISING TIDE BAR",
        thirdSectionRightBoxText:
            "It’s the coolest way to get from Central Park® to the Royal Promenade. Sip your favorite cocktail on Rising Tide, a moving bar that rises and descends between Deck 5 and Deck 8.",
        thirdSectionSpecialityNr: "12",
        thirdSectionSpecialityText: "SPECIALITY <br /> RESTAURANTS",
        thirdSectionBottomBoxTitle: "RISING TIDE BAR",
        thirdSectionBottomBoxText:
            "It’s the coolest way to get from Central Park® to the Royal Promenade. Sip your favorite cocktail on Rising Tide, a moving bar that rises and descends between Deck 5 and Deck 8.",
        lastSectionMainTitle: "ADULT INFO",
        lastSectionMainText:
            "There are some puzzles you solve and there are some puzzles you ESCAPE! In the new and exclusive Escape The Rubicon, you will be transported to another world and another time. Collaborate with friends, old and new, as you attempt to find the hidden clues needed to solve a collection of puzzles that will eventually unravel the mystery of the Rubicon!",
        lastSectionLeftBoxTitle: "LAFITE WINE TASTING",
        lastSectionLeftBoxText:
            "Up the ramp, around the curve and into the hole. Play on the green as you enjoy wide, blue ocean views. Mini golf is included in your fare, so play as much as you like. No reservation necessary.",
        lastSectionRightBoxTitle: "SOLARIUM",
        lastSectionRightBoxText:
            "A relaxing indoor-outdoor retreat. The crystal canopy area presents fantastic views and stays warm while you enjoy swimming pools, whirlpools and lounge area, as well as cascading lagoons on select ships.",
    },
    {
        day: 3,
        isSeaDay: true,
        destination: "Florence/Pisa (La Spezia), Italy",
        subHeaderLeftBoxTitle: "MINI GOLF",
        subHeaderLeftBoxText:
            "Up the ramp, around the curve and into the hole. Play on the green as you enjoy wide, blue ocean views. Mini golf is included in your fare, so play as much as you like. No reservation necessary.",
        subHeaderRightMainTitle: "BIGGER, BOLDER FAMILY MEMORIES.",
        subHeaderRightBoxTitle: "ESCAPE THE RUBICON",
        subHeaderRightBoxText:
            "There are some puzzles you solve and there are some puzzles you ESCAPE! In the new and exclusive Escape The Rubicon, you will be transported to another world and another time. Collaborate with friends, old and new, as you attempt to find the hidden clues needed to solve a collection of puzzles that will eventually unravel the mystery of the Rubicon!",
        secondSubHeaderLeftBoxTitle: "FLOWRIDER®",
        secondSubHeaderLeftBoxText:
            "The surf’s always up on the 40-foot-long FlowRider® surf simulator. Grab your board and get ready, 30,000 gallons of rushing awesome are headed your way.",
        secondSubHeaderInsiderTippText:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",
        thirdSectionTitle: "RAISE THE BAR",
        thirdSectionCompimentaryNr: "6",
        thirdSectionCompimentaryText: "COMPLIMENTARY <br /> RESTAURANTS",
        thirdSectionRightBoxTitle: "RISING TIDE BAR",
        thirdSectionRightBoxText:
            "It’s the coolest way to get from Central Park® to the Royal Promenade. Sip your favorite cocktail on Rising Tide, a moving bar that rises and descends between Deck 5 and Deck 8.",
        thirdSectionSpecialityNr: "12",
        thirdSectionSpecialityText: "SPECIALITY <br /> RESTAURANTS",
        thirdSectionBottomBoxTitle: "RISING TIDE BAR",
        thirdSectionBottomBoxText:
            "It’s the coolest way to get from Central Park® to the Royal Promenade. Sip your favorite cocktail on Rising Tide, a moving bar that rises and descends between Deck 5 and Deck 8.",
        lastSectionMainTitle: "ADULT INFO",
        lastSectionMainText:
            "There are some puzzles you solve and there are some puzzles you ESCAPE! In the new and exclusive Escape The Rubicon, you will be transported to another world and another time. Collaborate with friends, old and new, as you attempt to find the hidden clues needed to solve a collection of puzzles that will eventually unravel the mystery of the Rubicon!",
        lastSectionLeftBoxTitle: "LAFITE WINE TASTING",
        lastSectionLeftBoxText:
            "Up the ramp, around the curve and into the hole. Play on the green as you enjoy wide, blue ocean views. Mini golf is included in your fare, so play as much as you like. No reservation necessary.",
        lastSectionRightBoxTitle: "SOLARIUM",
        lastSectionRightBoxText:
            "A relaxing indoor-outdoor retreat. The crystal canopy area presents fantastic views and stays warm while you enjoy swimming pools, whirlpools and lounge area, as well as cascading lagoons on select ships.",
    },
    {
        day: 4,
        isSeaDay: false,
        destination: "Rome, Italy",
        arrive: "12:23",
        distance: "12KM",
        subHeaderTitle:
            "It’s easy to see why Barcelona is the most-visited city in Spain. Bit of fun intro text here.",
        subHeaderText:
            "As the capital of the country’s Catalonia region, this cityscape’s cultural mosaic pieces together a 2,000-year-old hodge-podge of sun-drenched beaches, cutting edge architecture and a world-renowned dining and drinking scene. <br /> <br /> Catalan architect Antoni Gaudí left his modernist handprint all over the city, while medieval treasures linger in historic Gothic Quarter squares. Get lost in the whimsical gardens of Park Güell or savour a chef-led Catalan cooking class. Browse art collections dedicated to Picasso and Miro – or ride a cable car to the top of Montjuïc Hill, relishing citywide views along the way.",
        insiderTipText:
            "One of the best ways to get round the city is by bike. There are many bire hire companies off La Rambla and guided tours.",
        thingsToDoArray: [
            {
                title: "SKY HIGH DELIGHTS",
                boxText:
                    "Get an up-close glimpse of La Sagrada Família, a cathedral masterwork designed by celebrated Catalan architect Antoni Gaudí. Marvel at its sky-piercing spires and then step inside to admire intricate mosaics, Montjuïc stone pillars and the Nativity façade. You can even climb to the tippy-top of the spires for panoramic city views.",
                imgSrc: CatedralImg,
                mainDivTop: "6.25rem",
                tagTitleLeft: "11.25rem",
                textImageDivRight: "13.25rem",
                imageTop: "5.3rem",
                imageLeft: "auto",
                textBoxTop: "22%",
                // textBoxLeft: textBoxResponsive ? "14%" : "24%",
                textBoxLeft: "24%",
                hasDepart: false,
                svgSrc: DottedLine1,
                svgTop: "-99%",
                svgRight: "12%",
            },
            {
                title: "LA RAMBLA’S DRINKS",
                boxText:
                    "Take a stroll along La Rambla’s pedestrian boulevard to experience the city’s pure essence. Souvenir shops, street artists, flower stalls, pavement cafes and Catalan folk sardana dancers set a lively scene. Its marvellous centrepiece, La Catedral, dates from the 1200s – and its tower delivers sweeping views of medieval Barcelona.",
                imgSrc: SeeImg,
                mainDivTop: "10.6rem",
                tagTitleLeft: "11.25rem",
                textImageDivRight: "13.25rem",
                imageTop: "2rem",
                imageLeft: "0",
                textBoxTop: "44%",
                textBoxLeft: "42%",
                hasDepart: false,
                svgSrc: DottedLine2,
                svgTop: "-21%",
                svgRight: "42%",
            },
            {
                title: "LOCAL CUISINE",
                boxText:
                    "Take a stroll along La Rambla’s pedestrian boulevard to experience the city’s pure essence. Souvenir shops, street artists, flower stalls, pavement cafes and Catalan folk sardana dancers set a lively scene. Its marvellous centrepiece, La Catedral, dates from the 1200s – and its tower delivers sweeping views of medieval Barcelona.",
                imgSrc: RamblaImg,
                mainDivTop: "10.6rem",
                tagTitleLeft: "18.75rem",
                textImageDivRight: "18.75rem",
                imageTop: "2rem",
                imageLeft: "18.75rem",
                textBoxTop: "71%",
                textBoxLeft: "5%",
                hasDepart: true,
                svgSrc: DottedLine3,
                svgTop: "-23%",
                svgRight: "38%",
            },
        ],
    },
];

export const getItinerayDetails = createAsyncThunk(
    "itineraryDays/get",
    async ({ itineraryUid, customerType, language, isLegend = false }, thunkAPI) => {
        const response = await apiRequest({
            payload: {
                data: {
                    // user_uid: getUserDetails().user_details.uid,
                    itinerary_uid: itineraryUid,
                    customer_type: customerType,
                    language: window.currentLanguage ? window.currentLanguage : language,
                },
            },
            requestType: isLegend
                ? requestType.getPublicItineraryDetailsLegend
                : requestType.getPublicItineraryDetails,
        });

        return response.data.data;
    }
);

export const itineraryDaysSlice = createSlice({
    name: "itineraryDays",
    initialState: {
        valueArray: shipDaysData,
        itineraryData: {},
        itineraryUid: null,
        customerType: null,
        loading: true,
        error: false,
        day: 1,
        status: "idle",
    },
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        incrementDay: (state) => {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.day += 1;
        },
        decrementDay: (state) => {
            state.day -= 1;
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        incrementDayByAmount: (state, action) => {
            state.day = action.payload;
        },
        updateItineraryUid: (state, action) => {
            state.itineraryUid = action.payload;
        },
        updateCustomerType: (state, action) => {
            state.customerType = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getItinerayDetails.pending, (state) => {
                state.loading = true;
            })
            .addCase(getItinerayDetails.fulfilled, (state, { payload }) => {
                // When the API call is successful and we get some data,the data becomes the `fulfilled` action payload
                state.loading = false;
                state.itineraryData = payload;
            })
            .addCase(getItinerayDetails.rejected, (state) => {
                state.loading = false;
                state.error = true;
            });
    },
});

export const {
    incrementDay,
    decrementDay,
    incrementDayByAmount,
    updateItineraryUid,
    updateCustomerType,
} = itineraryDaysSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.itineraryDays.value)`
export const selectItineraryDays = (state) => state.itineraryDays.valueArray;
export const selectDay = (state) => state.itineraryDays.day;
export const selectItineraryData = (state) => state.itineraryDays.itineraryData;
export const selectItineraryUid = (state) => state.itineraryDays.itineraryUid;
export const selectCustomerType = (state) => state.itineraryDays.customerType;
export const selectItineraryGeneral = (state) => state.itineraryDays;

export default itineraryDaysSlice.reducer;
